(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-package-picker]:not([data-picker-ready])').forEach(picker => {
      const choices = [...picker.querySelectorAll('[data-package-filter]')];
      const cards = [...picker.querySelectorAll('[data-package-group]')];
      const status = picker.querySelector('[data-package-status]');
      const beefNote = picker.querySelector('[data-package-beef-note]');
      if (!cards.length || !status) return;
      const matches = (card, key) => key === 'all' || (key === 'rind' ? card.dataset.packageSpecies === 'rind' : card.dataset.packageGroup === key);
      function select(key) {
        choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.packageFilter === key)));
        let count = 0;
        cards.forEach(card => { card.hidden = !matches(card, key); if (!card.hidden) count++; });
        status.textContent = `${count} ${count === 1 ? 'Paket' : 'Pakete'} in deiner Auswahl.`;
        if (beefNote) beefNote.hidden = key !== 'rind';
      }
      choices.forEach(choice => {
        const key = choice.dataset.packageFilter;
        if (key !== 'all' && !cards.some(card => matches(card, key))) { choice.hidden = true; return; }
        choice.addEventListener('click', () => select(key));
      });
      select('all'); picker.querySelector('.j-package-picker__controls').hidden = false;
      status.hidden = false; picker.dataset.pickerReady = 'true';
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
